import { IEquipment } from '../equipment.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentAtom from '../atoms/equipment.atom.ts'
import { useMemo } from 'react'

const useEquipment = (id: IEquipment['id']) => {
  const equipment = useRecoilValue(equipmentAtom).items

  return useMemo(() => {
    return equipment.find((e) => e.id === id)
  }, [equipment, id])
}

export default useEquipment
